import { useMemo } from 'react';
// convert folderId param to number or null
export function asFolderId(folderId) {
    if (typeof folderId !== 'string') {
        return null;
    }
    const parsed = parseInt(folderId);
    return isFinite(parsed) ? parsed : null;
}
export function useFolderId(folderId) {
    return useMemo(() => asFolderId(folderId), [folderId]);
}
//# sourceMappingURL=useFolderId.js.map